import { render, staticRenderFns } from "./CustomSec.vue?vue&type=template&id=3e2ffc0e&"
import script from "./CustomSec.vue?vue&type=script&lang=js&"
export * from "./CustomSec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports